export const removeQueryParamFromRoute = (route, router, queryParam) => {
  const originalValue = route?.query?.[queryParam];
  const query = { ...(route.query || {}) };
  delete query[queryParam];
  router.replace({ query });
  return originalValue;
};
